import {CryptoCurrenciesForEnovipayPayout} from '@bdswiss/common-enums'

const CRYPTO_NETWORK_OPTIONS = [
  {value: 'BTC', label: 'BTC'},
  {value: 'USDT/ERC20', label: 'USDT/ERC20'},
  {value: 'USDT/TRC20', label: 'USDT/TRC20'},
  {value: 'USDC/ERC20', label: 'USDC/ERC20'},
]

const CRYPTO_PAYOUT_NETWORK_OPTIONS = Object.values(CryptoCurrenciesForEnovipayPayout)

export {CRYPTO_NETWORK_OPTIONS, CRYPTO_PAYOUT_NETWORK_OPTIONS}
